export default __webpack_public_path__ + "static/media/yuman2.247eb3e7.png";